import { render, staticRenderFns } from "./datacalendario.vue?vue&type=template&id=09734bc0"
import script from "./datacalendario.vue?vue&type=script&lang=js"
export * from "./datacalendario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports